import React from "react";
import "./Template_2.css";

const Template_2_Footer = () => {
  return (
    <footer id="contact" className="Template_2_Footer footer-template-2">
      <div className="Template_2_Footer container">
        <div className="Template_2_Footer footer-content">
          {/* Column 1: About */}
          <div className="Template_2_Footer footer-column">
            <h3>VoyageVista</h3>
            <p>
              Crafting extraordinary travel experiences that create lifelong
              memories and inspire wanderlust.
            </p>
            <div className="Template_2_Footer social-links">
              <a href="#">
                <i className="fa-brands fa-facebook-f"></i>
              </a>
              <a href="#">
                <i className="fa-brands fa-twitter"></i>
              </a>
              <a href="#">
                <i className="fa-brands fa-instagram"></i>
              </a>
            </div>
          </div>

          {/* Column 2: Destinations */}
          <div className="Template_2_Footer footer-column">
            <h3>Popular Destinations</h3>
            <ul>
              <li>
                <a href="#">Bali, Indonesia</a>
              </li>
              <li>
                <a href="#">Swiss Alps</a>
              </li>
              <li>
                <a href="#">Tokyo, Japan</a>
              </li>
              <li>
                <a href="#">Paris, France</a>
              </li>
              <li>
                <a href="#">Santorini, Greece</a>
              </li>
            </ul>
          </div>

          {/* Column 3: Quick Links */}
          <div className="Template_2_Footer footer-column">
            <h3>Quick Links</h3>
            <ul>
              <li>
                <a href="#">About Us</a>
              </li>
              <li>
                <a href="#">Terms and Conditions</a>
              </li>
              <li>
                <a href="#">FAQ's</a>
              </li>
              <li>
                <a href="#">Privacy Policy</a>
              </li>
              <li>
                <a href="#">Refund Policy</a>
              </li>
              <li>
                <a href="#">Contact Us</a>
              </li>
            </ul>
          </div>

          {/* Column 4: Contact */}
          <div className="Template_2_Footer footer-column">
            <h3>Contact Us</h3>
            <ul>
              <li>
                <i className="fas fa-phone"></i> +1 (555) 123-4567
              </li>
              <li>
                <i className="fas fa-envelope"></i> info@voyagevista.com
              </li>
              <li>
                <i className="fas fa-map-marker-alt"></i> 456 Adventure Ave,
                Explorer City
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="Template_2_Footer copyright">
          <p>&copy; 2023 VoyageVista. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Template_2_Footer;
